import { Directive, HostListener, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoTab]'
})
export class AutoTabDirective {

  @Input()
  appAutoTab: number;

  constructor(
    private ele: ElementRef,
    private render: Renderer2
  ) { }

  getNextInput(el) {
    el = el.nextElementSibling;

    if (el === null || el.classList.contains('form-control')) {
      return el;
    } else {
      return this.getNextInput(el);
    }
  }

  @HostListener('keyup', ['$event'])
  autoTab(event) {
   if (this.ele.nativeElement.nextElementSibling !== null
      && this.ele.nativeElement.value.length === this.appAutoTab) {
    this.getNextInput(this.ele.nativeElement).focus();
   }
  };

}
